import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

const toIn = (cm) => (cm / 2.54).toFixed(1);

const ChartTable = ({ chart, unit }) => (
  <div className="-mx-1 overflow-x-auto" data-lenis-prevent>
    <table data-testid="size-guide-table" className="w-full min-w-[320px] border-collapse text-left text-sm">
      <thead>
        <tr className="border-b border-[#111111]">
          <th className="label py-3 pr-3 text-[10px] font-normal text-[#111111]/60">{unit === "in" ? "Inches" : "CM"}</th>
          {chart.sizes.map((s) => <th key={s} className="label py-3 text-center text-[11px] font-normal">{s}</th>)}
        </tr>
      </thead>
      <tbody>
        {chart.rows.map((r) => (
          <tr key={r.name} className="border-b border-[#111111]/15">
            <td className="label py-3 pr-3 text-[10px] text-[#111111]/70">{r.name}</td>
            {r.cm.map((v, i) => <td key={i} className="py-3 text-center tabular-nums">{unit === "in" ? toIn(v) : v}</td>)}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export const SizeGuide = ({ chart, image, note }) => {
  const [unit, setUnit] = useState("in");
  if (!chart && !image) return null;
  return (
    <Dialog>
      <DialogTrigger data-testid="size-guide-button" className="label draw-link text-[10px] text-[#111111]/70 hover:text-[#E2541B]">
        Size guide
      </DialogTrigger>
      <DialogContent data-testid="size-guide-dialog" data-lenis-prevent className="max-h-[90svh] w-[calc(100%-2rem)] max-w-[560px] overflow-y-auto rounded-none border-[#111111]/15 bg-[#F4F2EE] p-6 md:p-10">
        <DialogTitle className="font-['Geist',sans-serif] text-3xl font-light uppercase tracking-[-0.04em]">Size guide</DialogTitle>
        <DialogDescription className="text-sm text-[#111111]/70">Garment measurements, laid flat.</DialogDescription>
        {chart ? (
          <>
            <div className="mt-2 flex gap-1" role="group" aria-label="Units">
              {["in", "cm"].map((u) => (
                <button key={u} type="button" data-testid={`size-guide-unit-${u}`} aria-pressed={unit === u} onClick={() => setUnit(u)}
                  className={`label h-9 w-14 border text-[10px] transition-colors duration-300 ${unit === u ? "border-[#111111] bg-[#111111] text-[#F4F2EE]" : "border-[#111111]/25 hover:border-[#111111]"}`}>
                  {u}
                </button>
              ))}
            </div>
            <ChartTable chart={chart} unit={unit} />
          </>
        ) : (
          <img data-testid="size-guide-image" src={image} alt="Size chart" className="w-full mix-blend-multiply" />
        )}
        {note && <p className="label text-[10px] text-[#111111]/65">{note}</p>}
      </DialogContent>
    </Dialog>
  );
};
